// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3NbTV","overflowing":"ReadFullNote_overflowing__2EEMo"};